import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import { StateInterface } from '@/interfaces/projects';
import { FileDetails } from '@/interfaces/files';


const fileDetailsModule: Module<FileDetails, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default fileDetailsModule;